/**
 * Mixin for auto-refresh functionality (Vue 2 compatible)
 */
export default {
  data() {
    return {
      refreshTimer: null,
      isRefreshing: false,
      isPaused: true,
      countdown: 0,
      refreshIntervalSec: 30,
    }
  },

  beforeDestroy() {
    this.stopAutoRefresh()
  },

  methods: {
    isAutoRefreshBlocked() {
      return !!(this.isRefreshing || this.isAnalyzing)
    },

    startRefreshTimer(callback) {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer)
      }

      this.refreshTimer = setInterval(async () => {
        if (this.isPaused || this.hasChanges || this.isAutoRefreshBlocked()) {
          return
        }

        this.countdown--
        if (this.countdown <= 0) {
          const refreshed = await this.performRefresh(callback)
          if (refreshed) {
            this.countdown = this.refreshIntervalSec
          }
        }
      }, 1000)
    },

    async startAutoRefresh(callback, immediate = true) {
      this.isPaused = false
      this.countdown = this.refreshIntervalSec

      if (immediate && !this.isAutoRefreshBlocked()) {
        const refreshed = await this.performRefresh(callback)
        if (refreshed) {
          this.countdown = this.refreshIntervalSec
        }
      }

      this.startRefreshTimer(callback)
    },

    async performRefresh(callback) {
      if (this.isRefreshing || this.isAnalyzing) {
        return false
      }

      this.isRefreshing = true
      try {
        if (callback && typeof callback === 'function') {
          await callback()
        }
        return true
      } catch (error) {
        console.error('[AutoRefresh] Error:', error)
        return false
      } finally {
        this.isRefreshing = false
      }
    },

    stopAutoRefresh() {
      this.isPaused = true
      this.countdown = 0

      if (this.refreshTimer) {
        clearInterval(this.refreshTimer)
        this.refreshTimer = null
      }
    },

    applyRefreshIntervalSec(nextIntervalSec, callback) {
      const parsed = Number(nextIntervalSec)
      if (!Number.isFinite(parsed) || parsed <= 0) {
        return
      }

      this.refreshIntervalSec = parsed

      if (this.isPaused) {
        return
      }

      if (this.countdown > this.refreshIntervalSec) {
        this.countdown = this.refreshIntervalSec
      }

      if (callback && typeof callback === 'function') {
        this.startRefreshTimer(callback)
      }
    },

    async toggleAutoRefresh(callback, immediate = true) {
      if (this.isPaused) {
        await this.startAutoRefresh(callback, immediate)
      } else {
        this.stopAutoRefresh()
      }
    },

    async manualRefresh(callback) {
      if (this.isAutoRefreshBlocked()) {
        return false
      }

      const refreshed = await this.performRefresh(callback)
      if (refreshed) {
        this.countdown = this.refreshIntervalSec
      }
      return refreshed
    },
  },
}
